import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { Container, Flex, Box, css } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import Icon from '@solid-ui-components/ContentIcon';
import ContentContainer from '@solid-ui-components/ContentContainer';

const styles = {
  accordion: {
    '.accordion': {
      ' > div': {
        boxShadow: 'none',
      },
    },
    '.accordion__button': {
      cursor: 'pointer',
      position: 'relative',
      outline: 'none',
      backgroundColor: 'gray100',
      borderRadius: '8px',
    },
    '.accordion__button:hover': {
      backgroundColor: 'gray200',
    },
    '.accordion__button::before': {
      content: '" "',
      width: '7px',
      height: '7px',
      marginRight: '12px',
      borderColor: 'gray500',
      borderBottom: '2px solid',
      borderLeft: '2px solid',
      position: 'absolute',
      right: 4,
      top: '50%',
      transform: 'translate(0, -50%) rotate(225deg)',
    },
    '.accordion__button[aria-expanded="true"]::before, .accordion__button[aria-selected="true"]::before':
      {
        transform: 'translate(0, -50%) rotate(315deg)',
        transition: 'transform 0.35s ease-in',
      },
    '.accordion__button[aria-expanded="false"]::before, .accordion__button[aria-selected="false"]::before':
      {
        transform: 'translate(0, -50%) rotate(225deg)',
        transition: 'transform 0.15s ease-in',
      },
    '[hidden]': {
      display: 'none',
    },
    '.accordion__panel': {
      animation: 'fadeIn 0.25s ease-in',
      backgroundColor: 'gray100',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      px: '14px',
      py: '12px',
      borderTop: '1px solid #D0D5DD',
    },
    '.accordion__panel:hover': {
      backgroundColor: 'gray200',
    },
    '.accordion__item': {
      borderRadius: '8px',
      backgroundColor: 'gray100',
    },
    '.accordion__item:hover': {
      '.accordion__panel': {
        backgroundColor: 'gray200',
      },
      '.accordion__button': {
        backgroundColor: 'gray200',
      },
      backgroundColor: 'gray200',
    },
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0.5,
        transform: 'translate(0, -15%)',
      },
      '100%': {
        opacity: 1,
        transform: 'translate(0, 0%)',
      },
    },
  },
  container: {
    textAlign: 'center',
    '& h2': {
      mb: [null, 11, null, null, 16],
    },
  },
  wrapper: {
    p: [null, 0],
    maxWidth: [null, '100%', null, null, '790px'],
    mb: 4,
    display: ['none', 'block', 'block', 'block', 'none'],
  },
  accordionContainer: {
    alignItems: 'center',
  },
  linksContainer: {
    flexDirection: 'column',
    gap: '8px',
  },
  link: {
    textDecoration: 'none',
    color: '#475467',
  },
};

const KnowledgeBaseArticleMobileNav = ({
  content: { text, collection, icon },
}) => (
  <Container sx={styles.wrapper}>
    {text && (
      <>
        <Box sx={styles.container}>
          <ContentText content={text} />
        </Box>
      </>
    )}
    <Box sx={styles.accordion}>
      <Accordion allowZeroExpanded>
        {collection?.map(({ container, text, buttons }, index) => (
          <ContentContainer
            content={container}
            key={`item-${index}`}
            variant='cards.primary'
            sx={{ '& + &': { mt: 3 } }}
          >
            <AccordionItem uuid={index === 0 ? 1 : undefined}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <Flex sx={styles.accordionContainer} px='14px' py='12px'>
                    <Icon content={icon} size='xs' mr='3' p='2' round />
                    <ContentText content={text?.[0]} mb='0' pr='9' />
                  </Flex>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <Flex sx={styles.linksContainer}>
                  {buttons.map((b, i) => (
                    <a css={css(styles.link)} key={`link-${i}`} href={b.link}>
                      {b.text}
                    </a>
                  ))}
                </Flex>
              </AccordionItemPanel>
            </AccordionItem>
          </ContentContainer>
        ))}
      </Accordion>
    </Box>
  </Container>
);

export default KnowledgeBaseArticleMobileNav;
